import React from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative pt-16 pb-20 lg:pt-24 lg:pb-28 overflow-hidden bg-gradient-to-b from-green-50 to-white" data-id="element-75">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-76">
        <div className="max-w-4xl mx-auto text-center" data-id="element-77">
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-green-100 text-green-800 font-semibold text-sm tracking-wider uppercase" data-id="element-78">
            Para Hispanos 55+ en USA
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 tracking-tight mb-6 leading-tight" data-id="element-79">
            El Código de la Longevidad:{' '}
            <span className="text-green-700 block mt-2" data-id="element-80">Metabolismo 55+</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 mb-10 font-medium leading-relaxed max-w-3xl mx-auto" data-id="element-81">
            Recupere la energía que tenía hace 10 años y proteja su salud{' '}
            <span className="underline decoration-orange-500 decoration-4 underline-offset-4" data-id="element-82">
              sin renunciar al sabor de nuestra comida latina.
            </span>
          </p>

          <div className="relative max-w-lg mx-auto mb-12" data-id="element-83">
            <div className="absolute inset-0 bg-green-200 rounded-3xl transform rotate-3 scale-105 opacity-50 blur-lg" data-id="element-84"></div>
            <img src="https://cdn.magicpatterns.com/uploads/qm8HxQY8cCfR2p3x6vKEgq/metabolismo_55.png" alt="El Código de la Longevidad en iPad" className="relative rounded-2xl shadow-2xl mx-auto border-4 border-white w-full object-cover" data-id="element-85" />
          </div>

          <CTAButton data-id="element-86" />
        </div>
      </div>
    </section>;
}